/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Aside_Coach_CtaInputs */

const en_contact_aside_coach_cta = /** @type {(inputs: Contact_Aside_Coach_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find your coach`)
};

const pl_contact_aside_coach_cta = /** @type {(inputs: Contact_Aside_Coach_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź trenera`)
};

/**
* | output |
* | --- |
* | "Find your coach" |
*
* @param {Contact_Aside_Coach_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside_coach_cta = /** @type {((inputs?: Contact_Aside_Coach_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Aside_Coach_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside_coach_cta(inputs)
	return en_contact_aside_coach_cta(inputs)
});